import './Steps.scss';

import React, { FunctionComponent } from 'react';

import { useTranslation } from 'react-i18next';

type Props = {
  start: number;
  end: number;
  showAllDoneMessage?: boolean;
};

const Steps: FunctionComponent<Props> = ({
  start,
  end,
  showAllDoneMessage,
}) => {
  const { t } = useTranslation();

  return (
    <div className="giving-checkout-steps">
      {showAllDoneMessage && start === end
        ? t('steps.allDone')
        : t('steps.step', { start, end })}
    </div>
  );
};

export default Steps;
